export default "__VITE_ASSET__Ceep629M__"